<template>
  <div class="payment-middle-page">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      <span>准备支付中...</span>
    </div>

    <!-- 错误提示 -->
    <div v-if="error" class="error">
      <p>{{ error }}</p>
      <el-button @click="$router.back()">返回</el-button>
      <el-button v-if="canRetry" type="primary" @click="retryPayment"
        >重新尝试</el-button
      >
    </div>
    <!-- 支付宝支付：自动提交表单（H5 直接跳转） -->
    <form
      v-if="payMethod === 'alipay' && alipayParams"
      id="alipayForm"
      method="post"
      :action="`https://openapi.alipay.com/gateway.do?charset=${alipayParams.charset}`"
    >
      <!-- 表单参数中不再包含 charset，仅在 URL 中存在 -->
      <input type="hidden" name="app_id" :value="alipayParams.app_id" />
      <input
        type="hidden"
        name="biz_content"
        :value="alipayParams.biz_content"
      />
      <input type="hidden" name="format" :value="alipayParams.format" />
      <input type="hidden" name="method" :value="alipayParams.method" />
      <input type="hidden" name="notify_url" :value="alipayParams.notify_url" />
      <input type="hidden" name="return_url" :value="alipayParams.return_url" />
      <input type="hidden" name="sign_type" :value="alipayParams.sign_type" />
      <input type="hidden" name="timestamp" :value="alipayParams.timestamp" />
      <input type="hidden" name="version" :value="alipayParams.version" />
      <input type="hidden" name="sign" :value="alipayParams.sign" />
    </form>

    <!-- 微信支付：JSAPI 调起 -->
    <!-- 微信支付：根据环境显示不同提示 -->
    <div
      v-if="payMethod === 'wechat' && wechatParams && error == ''"
      class="wechat-tip"
    >
      <p>正在唤起微信支付...</p>
    </div>
  </div>
</template>

<script>
/* global WeixinJSBridge */
export default {
  name: "PaymentPage",
  data() {
    return {
      payMethod: "", // alipay/wechat
      alipayParams: null,
      wechatParams: null,
      loading: true,
      error: "",
      paySn: "", // 保存当前支付单号，用于重试
      canRetry: true, // 是否允许重试支付
    };
  },
  async created() {
    try {
      // 1. 从路由参数获取支付单号（paySn）
      const isH5 =
        this.$route.query.is_h5 !== undefined ? this.$route.query.is_h5 : false; //H5端
      this.isH5 = isH5;
      const paySn = this.$route.query.pay_sn;
      const payMethod = this.$route.query.pay_method;
      const expireTime = this.$route.query.expire_time;
      const Sign = this.$route.query.sign;
      console.log(paySn, payMethod, expireTime, Sign, "paySn");
      if (!paySn) {
        this.error = "支付参数错误";
        this.loading = false;
        this.canRetry = false; // 参数错误无法重试
        return;
      }

      // 2. 调用后端接口，获取支付参数
      const res = await this.$get("/payment/pay_page", {
        params: {
          pay_sn: paySn,
          pay_method: payMethod,
          expire_time: expireTime,
          sign: Sign,
          is_h5: isH5 ? 1 : 0,
        },
      });
      this.payMethod = payMethod;
      if (res.data.code !== 1) {
        this.error = res.data.msg || "获取支付参数失败";
        this.loading = false;
        return;
      }
      const data = res.data.data;
      console.log(data, "data");

      // 3. 调用后端接口，标记该 paySn 为已扫码
      await this.$post("/payment/mark_scanned", { pay_sn: paySn });

      // 4. 区分支付方式，处理参数
      if (this.payMethod === "alipay") {
        this.alipayParams = data;
        // H5 端延迟 500ms 提交（给用户提示时间），PC 端立即提交
        setTimeout(
          () => {
            this.submitAlipayForm();
          },
          this.isH5 ? 1000 : 0
        );
        // // DOM 加载完成后自动提交表单
        // this.$nextTick(() => {
        //   document.getElementById("alipayForm").submit();
        // });
      } else if (this.payMethod === "wechat") {
        this.wechatParams = data;
        this.initWechatPay(); // 调用微信支付
      }
      this.loading = false;
    } catch (err) {
      this.error = "网络异常，请重试";
      this.loading = false;
      console.error("支付中间页异常:", err);
    }
  },
  methods: {
    // 支付宝表单提交（处理可能的提交失败）
    submitAlipayForm() {
      try {
        const form = document.getElementById("alipayForm");
        if (form) form.submit();
      } catch (err) {
        this.error = "支付宝支付跳转失败，请手动重试";
        this.loading = false;
        console.error("支付宝表单提交失败:", err);
      }
    },
    // 检测是否在微信内置浏览器中
    isWechatEnv() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return userAgent.includes("micromessenger");
    },
    // 微信支付初始化（JSAPI 调起）
    initWechatPay() {
      if (!this.isWechatEnv()) {
        this.error = this.isH5
          ? "请在微信中打开此链接以完成支付"
          : "请使用微信扫描二维码完成支付";
        this.loading = false;
        return;
      }

      // 先判断是否在微信环境
      // if (!this.isWechatEnv()) {
      //   // 非微信环境：跳转微信H5支付链接
      //   if (this.wechatParams.mweb_url) {
      //     window.location.href = this.wechatParams.mweb_url;
      //   } else {
      //     this.error = "获取微信支付链接失败";
      //   }
      //   return;
      // }

      // 检测微信环境的 WeixinJSBridge
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.callWechatPay,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.callWechatPay);
          document.attachEvent("onWeixinJSBridgeReady", this.callWechatPay);
        }
      } else {
        this.callWechatPay();
      }
    },

    // 调用微信支付
    callWechatPay() {
      const {
        appId,
        timeStamp,
        nonceStr,
        package: pkg,
        sign,
        signType,
      } = this.wechatParams;
      // 检查关键参数是否存在
      if (!appId || !timeStamp || !nonceStr || !pkg || !sign) {
        this.error = "支付参数不完整，请重试";
        this.loading = false;
        this.$message.error("缺少支付参数：");
        console.error("缺少支付参数：", {
          appId,
          timeStamp,
          nonceStr,
          pkg,
          sign,
        });
        return;
      }
      // 调用微信 JSAPI 支付
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId, // 注意大写 I（必须与后端返回的参数名一致）
          timeStamp: timeStamp, // 必须是字符串类型（后端生成时确保为字符串）
          nonceStr: nonceStr,
          package: pkg, // 格式为 "prepay_id=xxx"
          signType: signType || "MD5", // 签名方式（与后端一致，通常为 MD5 或 HMAC-SHA256）
          paySign: sign, // 关键：微信要求的参数名是 paySign，这里用后端返回的 sign 赋值
        },
        (res) => {
          // 支付结果回调
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            // 支付成功：短暂提示后跳转订单列表
            this.$message.success("支付成功！");
            setTimeout(() => {
              // 添加随机参数（如时间戳），避免浏览器缓存页面
              this.$router.push({
                path: "/about-me/my-listings/order-list",
                query: { t: Date.now() }, // 随机参数，每次跳转都不同
              });
              // this.$router.push("/about-me/my-listings/order-list");
            }, 1000);
          } else if (
            res.err_msg === "get_brand_wcpay_request:cancel" ||
            res.err_msg === "get_brand_wcpay_request:fail"
          ) {
            // 支付取消或失败
            this.$message.error("支付取消或失败");
            this.loading = false;
            this.$router.push({
              path: "/about-me/my-listings/order-list",
              query: { t: Date.now() }, // 随机参数，每次跳转都不同
            });
            // this.$router.push("/about-me/my-listings/order-list");
          }
        }
      );
    },

    // 重新尝试支付（用于错误场景重试）
    retryPayment() {
      this.loading = true;
      this.error = "";
      // 重新调用支付参数接口（复用 created 中的核心逻辑）
      this.$get("/payment/pay_page", {
        params: {
          pay_sn: this.paySn,
          pay_method: this.payMethod,
          sign: this.$route.query.sign,
          is_mobile: this.isMobile ? 1 : 0,
        },
      })
        .then((res) => {
          if (res.data.code === 1) {
            const data = res.data.data;
            if (this.payMethod === "alipay") {
              this.alipayParams = data;
              this.submitAlipayForm();
            } else if (this.payMethod === "wechat") {
              this.wechatParams = data;
              this.initWechatPay();
            }
            this.loading = false;
          } else {
            this.error = res.data.msg || "重新获取支付参数失败";
            this.loading = false;
          }
        })
        .catch((err) => {
          this.error = "网络异常，重试失败";
          this.loading = false;
          console.error("重试支付失败:", err);
        });
    },
  },
};
</script>

<style scoped>
.payment-middle-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
/* 加载状态样式 */
.loading {
  text-align: center;
  color: #333;
}
.loading i {
  font-size: 24px;
  margin-bottom: 10px;
  color: #409eff;
  animation: spin 1.5s linear infinite;
}

/* 错误提示样式 */
.error {
  text-align: center;
  color: #f56c6c;
  max-width: 300px;
}
.error i {
  font-size: 24px;
  margin-bottom: 10px;
}
.error p {
  margin-bottom: 15px;
  line-height: 1.5;
}
.error button {
  margin: 0 5px;
}
/* 微信支付提示样式 */
.wechat-tip {
  text-align: center;
  color: #333;
}
.wechat-tip i {
  font-size: 24px;
  margin-bottom: 10px;
  color: #409eff;
  animation: spin 1.5s linear infinite;
}
.wechat-env-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 8px;
}

/* 加载动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
